import classNames from 'classnames';
import React from 'react';
import styles from './Body.module.css';

export type CreationLayoutBody = {
  leftGrid?: React.ReactNode;
  rightGrid?: React.ReactNode;
  children: React.ReactNode;
};

const Body = ({ leftGrid, rightGrid, children }: CreationLayoutBody) => {
  return (
    <div
      className={classNames([
        styles.body,
        !rightGrid ? styles.noRightGrid : null,
      ])}
    >
      <div className={styles.left}>
        <div className={styles.leftGridContent}>{leftGrid}</div>
      </div>
      <div className={styles.center}>
        <div className={styles.centerContent}>{children}</div>
      </div>
      {rightGrid && (
        <div className={styles.right}>
          <div className={styles.rightGridContent}>{rightGrid}</div>
        </div>
      )}
    </div>
  );
};

export default Body;
